<template>
    <FormSection title="Implantable Devices" :full-height="false" :application="application">
        <template #content>
            <div class="row pt-2 mx-3 g-0">
                <div class="d-flex flex-row mb-1 card p-2 w-100" v-if="!isAddRequested">
                    <div class="form-group mb-0">
                        <label class="me-2">Status</label>
                        <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                            <label
                                :class="`btn btn-outline-secondary font-size-xs ${
                                    selectedStatus == null ? 'active' : ''
                                }`"
                                @click="setStatus(null)"
                            >
                                <input type="radio" hidden name="is-current" autocomplete="off" /> All
                            </label>
                            <label
                                v-for="deviceStatus in deviceStatusEnum"
                                :class="`btn btn-outline-secondary font-size-xs ${
                                    deviceStatus.value === selectedStatus ? 'active' : ''
                                }`"
                                @click="setStatus(deviceStatus.value)"
                            >
                                <input type="radio" hidden name="is-current" autocomplete="off" />
                                {{ deviceStatus.name }}
                            </label>
                        </div>
                    </div>
                    <button
                        class="btn btn-sm btn-primary ms-auto"
                        @click="openAddImplantableDevice()"
                        v-if="!isAddRequested"
                    >
                        Add Implantable Device
                    </button>
                </div>
                <div
                    :class="`card px-lg-5 py-2 mb-2 w-100 h-100 animated ${
                        isAddRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
                    }`"
                    v-if="isAddRequested"
                >
                    <h5 class="text-capitalize">Add Implantable Device</h5>
                    <ImplantableDeviceForm
                        ref="implantableDeviceForm"
                        v-if="isAddRequested"
                        :application="application"
                        v-model:isDeviceValidated="isDeviceValidated"
                        :implantable-device="implantableDevice"
                        :isSaveInProgress="isAddInProgress"
                    />
                    <div class="text-center mt-1" v-if="!isAddInProgress">
                        <button
                            type="button"
                            class="btn btn-primary btn-md me-2"
                            @click="saveNewImplantableDevice()"
                            :disabled="!isDeviceValidated"
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            class="btn btn-primary btn-md me-2"
                            @click="saveNewImplantableDevice(false)"
                            :disabled="!isDeviceValidated"
                        >
                            Save and Add Another
                        </button>
                        <button
                            type="button"
                            class="btn btn-outline-secondary btn-md"
                            @click="closeAddImplantableDevice()"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
                <Pagination ref="paginationInstance" :page-changed="pageChangedCallback" :is-loading="isLoading">
                    <table
                        id="ImplantableDevice__Table"
                        class="table table-responsive-md border border-gray position-static"
                    >
                        <thead>
                            <tr class="table-header">
                                <th v-if="hasData">
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="udi"
                                    >
                                        Unique Device Identifiers (UDI)
                                    </SortableTh>
                                </th>
                                <th v-else>Unique Device Identifiers (UDI)</th>
                                <th>
                                    GMDN PT Name
                                    <span>
                                        <i
                                            class="fas fa-info-circle text-info"
                                            v-tooltip="{
                                                title: 'Global Medical Device Nomenclature (GMDN) Preferred Term (PT) Name'
                                            }"
                                        ></i>
                                    </span>
                                </th>
                                <th>Date of Implant</th>
                                <th class="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Devices Found.</h3>
                                </td>
                            </tr>
                            <tr v-if="isLoading" v-for="i of loadingCount" class="table-loading">
                                <td v-for="i of columns">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Implantable Devices" :try-again="resetList">
                                    </ErrorMessageHandler>
                                </td>
                            </tr>
                        </tbody>
                        <ImplantableDeviceRow
                            v-if="!isLoading && !isError && hasData"
                            v-for="item in page.Items"
                            :implantable-device="item"
                            :columns="columns"
                            :device-status-enum="deviceStatusEnum"
                            :reset-list="resetList"
                            :patient-id="patientId"
                            :application="application"
                            :accountId="accountId"
                        ></ImplantableDeviceRow>
                    </table>
                </Pagination>
            </div>
        </template>
    </FormSection>
</template>

<script src="./ImplantableDeviceSection.ts"></script>
